export const ICON_EXTEND_MODAL = require('../../assets/images/extend-icon.png')

export const SOCKET_DISCONNECTED = 0
export const SOCKET_CONNECTED = 1

export const STATE_ACTIVATE = 0
export const STATE_HOME = 1
export const STATE_WAITING = 2

export const MESSAGE_TYPE_ERROR = 0
export const MESSAGE_TYPE_SUCCESS = 1
export const MESSAGE_DISMISS_TIMEOUT = 15000 // in milliseconds
export const EARLY_CHECKIN_DURATION = 15 // in minutes

export const ROOM_STATUS_FREE = 0
export const ROOM_STATUS_BUSY = 1
export const ROOM_STATUS_WAITING = 2

export const CREATE_ACTION = 'create'
export const CREATE_AND_CHECKIN_ACTION = 'create_and_checkin'
export const EARLY_CHECKIN_ACTION = 'early_checkin'
export const CHECKIN_ACTION = 'checkin'
export const EXTEND_ACTION = 'extend'
export const END_ACTION = 'end'
export const DELETE_ACTION = 'delete'

export const CONFIG_STATUS_PENDING = 'pending'

export const DEVICE_TYPE = 'meeting_room_display'